{
	"altLogo": "logo",
	"clientGallery": "Client Gallery",
	"descClientGallery": "Better way to share, deliver, proof and sell",
	"descMobileGallery": "Simple, personalized mobile photo albums",
	"descPhotoEditor": "All-in-one photo editor powered by AI",
	"descStore": "Your online store for prints and downloads",
	"descStudioManager": "Photography business management",
	"descWebsite": "Build your own beautiful portfolio website",
	"mobileGalleryApp": "Mobile Gallery App",
	"photoEditor": "Photo Editor",
	"store": "Store",
	"studioManager": "Studio Manager",
	"viewDashboard": "View Dashboard",
	"website": "Website"
}
